'use client'

// React Imports
import { useRef, type ReactNode } from 'react'

const AuthBackdrop = ({ children }: { children: ReactNode }) => {
  const rootRef = useRef<HTMLDivElement>(null)

  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    const root = rootRef.current

    if (!root) return

    const rect = root.getBoundingClientRect()

    root.style.setProperty('--spot-x', `${event.clientX - rect.left}px`)
    root.style.setProperty('--spot-y', `${event.clientY - rect.top}px`)
  }

  const offScreen = { '--spot-x': '-100vw', '--spot-y': '-100vh' } as React.CSSProperties

  return (
    <div
      ref={rootRef}
      onPointerMove={handlePointerMove}
      style={offScreen}
      className='group/backdrop bg-background relative isolate flex min-h-svh flex-col overflow-hidden'
    >
      {/*
        ! ДЭВСГЭР НЬ MAXIMUS-ИЙН ЗУРАГ. Өмнө нь загварын өөрийн хяналтын
        ! самбарын дэлгэцийн агшин (`dashboards-1.webp`) байсан — өөр
        ! бүтээгдэхүүний дэлгэц манай нэвтрэх хуудсан дээр байх нь утгагүй.
        !
        ! НЭГ ЗУРАГ, ХОЁР СЭДЭВТ. Гэрэл/харанхуйд өөр өөр файл хэрэггүй:
        ! дээр нь тавьсан `bg-muted/75` / `dark:bg-background/80` давхарга
        ! хоёр сэдэвт тохирох тодролыг өөрөө өгнө.
      */}
      <div aria-hidden className='pointer-events-none absolute inset-0 -z-30 scale-105'>
        <img
          src='/images/og-image.jpg'
          alt=''
          className='size-full object-cover opacity-90 blur-[7px] saturate-[0.3]'
        />
      </div>

      <div aria-hidden className='bg-muted/75 dark:bg-background/80 pointer-events-none absolute inset-0 -z-20' />

      <div
        aria-hidden
        className='pointer-events-none absolute inset-0 -z-10 scale-105 opacity-0 transition-opacity duration-500 group-hover/backdrop:opacity-100 motion-reduce:hidden'
        style={{
          maskImage: 'radial-gradient(circle 300px at var(--spot-x) var(--spot-y), black 0%, transparent 70%)',
          WebkitMaskImage: 'radial-gradient(circle 300px at var(--spot-x) var(--spot-y), black 0%, transparent 70%)'
        }}
      >
        <img src='/images/og-image.jpg' alt='' className='size-full object-cover' />
      </div>

      {children}
    </div>
  )
}

export default AuthBackdrop
